import { createRpcClientV2 } from 'rpc-client-utils';
import { shareDocumentRpc } from '../../../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsDocumentService';
const getURI = contentId => `presentations/v1/deck/${contentId}/share`;
const getInsertContent = ({
  shortLink,
  name
}) => {
  return {
    url: shortLink,
    text: name
  };
};
export function renderDocument({
  httpClient,
  contactEmail,
  contentId,
  requireEmail = true,
  allowDownload = true
}) {
  const skipForm = !requireEmail;
  const promise = httpClient.post(getURI(contentId), {
    query: {
      sharedWith: contactEmail,
      skipForm,
      hasDownload: allowDownload
    }
  }).then(res => {
    return getInsertContent(res);
  }).catch(error => {
    return Promise.reject(error);
  });
  return promise;
}
export async function renderDocumentCHIRP({
  httpClient,
  contactEmail,
  contentId,
  documentName,
  requireEmail = true,
  allowDownload = true
}) {
  var _response$shortLink;
  const rpcClient = createRpcClientV2({
    hubHttpClient: httpClient
  });
  const response = await rpcClient.call(shareDocumentRpc, {
    request: {
      documentId: contentId,
      name: documentName,
      sharedWithEmail: contactEmail,
      hasDownload: allowDownload,
      skipForm: !requireEmail
    }
  });
  return getInsertContent({
    shortLink: (_response$shortLink = response.shortLink) !== null && _response$shortLink !== void 0 ? _response$shortLink : '',
    name: response.name
  });
}